// Import: Middleware Action & Custom Types
import { CLEAN_ADD_LINE, CLEAN_ADD_LINE_ERROR } from '_models/redux/types';

// Action function
export const cleanAddLine = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_ADD_LINE,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_ADD_LINE_ERROR,
    });
  }
};
